import { ApiParams, BaseClient, IActionResponse, IActionResult, IPagedResult, } from "../../../assets/utils/lib";
import { GridRssFeedDto, LookupDto, RssFeedDto, SearchDto } from "../../dto";

export class RssFeedClient extends BaseClient {
  routes = ["pophub", "RssFeed"];

  async getRssFeedAsync(id: string | undefined): Promise<RssFeedDto> {
    const actions: string[] = ["GetRssFeed"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];

    const result: RssFeedDto = await this.getAsync<RssFeedDto>(actions, params);
    return result;
  }

  async getRssFeedsAsync(): Promise<RssFeedDto[]> {
    const actions: string[] = ["GetAllRssFeeds"];

    const result: RssFeedDto[] = await this.getAsync<RssFeedDto[]>(actions);
    return result;
  }

  async getCommunityRssFeedsAsync(
    communityId?: string | undefined
  ): Promise<RssFeedDto[]> {
    const actions: string[] = ["GetCommunityRssFeeds"];
    const params: ApiParams[] = [
      new ApiParams("communityId", communityId, true),
    ];

    const result: RssFeedDto[] = await this.getAsync<RssFeedDto[]>(
      actions,
      params
    );
    return result;
  }

  async searchRssFeedAsync(
    payload: SearchDto | undefined
  ): Promise<IPagedResult<GridRssFeedDto>> {
    const actions: string[] = ["SearchRssFeed"];
    const result: IPagedResult<GridRssFeedDto> = await this.postAsync<
      SearchDto,
      GridRssFeedDto,
      IPagedResult<GridRssFeedDto>
    >(actions, payload);
    return result;
  }

  async saveRssFeedAsync(
    payload: RssFeedDto | undefined
  ): Promise<IActionResult<RssFeedDto>> {
    const actions: string[] = ["SaveRssFeed"];
    return await this.postAsync<RssFeedDto>(actions, payload);
  }

  async deleteRssFeedAsync(id?: string | undefined): Promise<IActionResponse> {
    const actions: string[] = ["DeleteRssFeed"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];

    return await this.deleteAsync(actions, params);
  }

  async getLookupsAsync(): Promise<{
    communities: LookupDto[];
    rssFeedType: LookupDto[];
  }> {
    const actions: string[] = ["GetLookups"];
    const result = await this.getAsync<{
      communities: LookupDto[];
      rssFeedType: LookupDto[];
    }>(actions, []);
    return result;
  }
}
